import { Button, Form, Input, Select } from "antd";
import { useDiscount } from "./DiscountStore";
import { useEffect } from "react";
import { useForm } from "antd/es/form/Form";

export default function Edit() {
    let {ed, updateDiscount} = useDiscount()
    let [form] = useForm();
    useEffect(() => {
        form.setFieldsValue(ed)
    }, [ed])
    return (
        <Form form={form}
            onFinish={updateDiscount}
            layout="vertical"
        >
            <Form.Item name={'id'} hidden>
                <Input />
            </Form.Item>
            <Form.Item
                name="code"
                label="Kodi"
                rules={[{ required: true }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name="type"
                label="Turi"
                rules={[{ required: true }]}
            >
                <Select
                    options={[
                        { value: 'fixed', label: 'Summa' },
                        { value: 'percent', label: 'Foiz' },
                    ]}
                />
            </Form.Item>
            <Form.Item
                name="amount"
                label="Miqdor"
                rules={[{ required: true }]}
            >
                <Input type="number" />
            </Form.Item>
            <Form.Item
                name="limittime"
                label="Muddati"
                rules={[{ required: true }]}
            >
                <Input type="date" />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">Saqlash</Button>
            </Form.Item>
        </Form>
    )
}